import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './Image.css';

const TestableImg = testable(QA_MALT, 'img');

const Image = (props) => {
  const classes = classnames(styles.image, props.className);

  return <TestableImg {...props} className={classes} testId={props.testId} />;
};

Image.displayName = 'Image';

Image.propTypes = {
  /** assign a custom className to the image.
   *
   * You can pass along any other standard HTML image prop into the component.
   *
   */
  className: PropTypes.string,
  /** define a testid for the image */
  testId: PropTypes.string,
};

export default Image;
